// https://observablehq.com/@mbostock/localized-number-parsing
var NumberParser = /** @class */ (function () {
    function NumberParser(locale) {
        var _a, _b;
        var parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
        var numerals = new Intl.NumberFormat(locale, { useGrouping: false })
            .format(9876543210)
            .split('')
            .reverse();
        var index = new Map(numerals.map(function (d, i) { return [d, i]; }));
        this._group = new RegExp("[".concat((_a = parts.find(function (d) { return d.type === 'group'; })) === null || _a === void 0 ? void 0 : _a.value, "]"), 'g');
        this._decimal = new RegExp("[".concat((_b = parts.find(function (d) { return d.type === 'decimal'; })) === null || _b === void 0 ? void 0 : _b.value, "]"));
        this._numeral = new RegExp("[".concat(numerals.join(''), "]"), 'g');
        this._index = function (d) { return "".concat(index.get(d)); };
    }
    NumberParser.prototype.parse = function (input) {
        var string = input
            .trim()
            .replace(this._group, '')
            .replace(this._decimal, '.')
            .replace(this._numeral, this._index);
        return string ? +string : Number.NaN;
    };
    return NumberParser;
}());
var nbParser = new NumberParser('nb');
var enParser = new NumberParser('en');
export var parseNumber = function (number, locale) {
    var parser = locale === 'en' ? enParser : nbParser;
    var parsed = parser.parse("".concat(number).replace(/\s/g, ''));
    return Number.isNaN(parsed) ? null : parsed;
};
